import React from "react";
import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";
import IadaBadge from "@/components/IadaBadge";
import RoiSimulator from "@/components/RoiSimulator";
import { Building2, KeyRound, LineChart, Handshake, Users2 } from "lucide-react";

const PILLARS = [
  { icon: Handshake, title: "Modelo B2B2C", desc: "Tu institución financia el acceso; tus ejecutivos aprenden y avanzan." },
  { icon: KeyRound, title: "Licencias flexibles", desc: "Asigna licencias por programa o por cohort, con revocación y auditoría." },
  { icon: LineChart, title: "Métricas de negocio", desc: "Dashboard de adopción, avance y correlación con KPIs comerciales." },
  { icon: Users2, title: "Consola white-label", desc: "Tu marca, tu color, tu dominio. Portal partner sin fricción." },
];

export default function Partners() {
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-xs uppercase tracking-widest text-[#F26A21] font-semibold">Partnership</p>
        <h1 className="mt-2 text-4xl sm:text-5xl font-bold text-[#0B0B0B] font-display leading-tight max-w-3xl">
          Conviértete en partner del ecosistema DCC.
        </h1>
        <p className="mt-4 text-lg text-[#0B0B0B] max-w-3xl leading-relaxed">
          Ofrece a tus clientes y empleados acceso a 193 programas del sector financiero y bursátil como beneficio de fidelización,
          onboarding o desarrollo profesional — con tu marca y tus reglas.
        </p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div key={i} className="p-5 bg-[#F9FAFB] border border-gray-200 rounded-xl">
                <div className="w-10 h-10 rounded-md bg-[#F26A21]/20 border border-[#F26A21]/40 flex items-center justify-center mb-3">
                  <Icon className="w-5 h-5 text-[#F26A21]" />
                </div>
                <h3 className="text-base font-semibold text-[#0B0B0B]">{p.title}</h3>
                <p className="mt-2 text-sm text-gray-600 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 grid lg:grid-cols-3 gap-6">
          {[
            { name: "Banco Alfa", color: "#F26A21", industry: "Neobank corporativo", users: "1,200+ ejecutivos formados" },
            { name: "Demo Bank", color: "#10B981", industry: "Banca comercial", users: "800+ cohort activo" },
            { name: "Institución partner", color: "#F59E0B", industry: "Casa de bolsa", users: "En incorporación" },
          ].map((p, i) => (
            <div key={i} className="p-6 bg-[#F9FAFB] border border-gray-200 rounded-xl">
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: p.color }} />
                <p className="font-display font-bold text-lg text-[#0B0B0B]">{p.name}</p>
              </div>
              <p className="mt-3 text-sm text-gray-600">{p.industry}</p>
              <p className="mt-1 text-sm text-[#0B0B0B] font-medium">{p.users}</p>
            </div>
          ))}
        </div>

        <RoiSimulator />

        <div className="mt-16 p-8 lg:p-12 rounded-2xl bg-[#F9FAFB] border border-gray-200" data-testid="partners-iada">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-xs uppercase tracking-widest text-[#F26A21] font-semibold">Nuestra alianza académica</p>
              <h2 className="mt-2 text-3xl font-bold text-[#0B0B0B] font-display">Alianza académica DCC × IADA</h2>
              <p className="mt-3 text-gray-600 leading-relaxed">
                DCC es aliado educativo de IADA — Instituto de Alta Dirección · Anáhuac Business School.
                Los programas destacados del catálogo cuentan con aval académico de IADA. DCC opera de
                forma independiente y mantiene una alianza estratégica con IADA para respaldar sus
                programas de alta dirección y certificaciones ejecutivas.
              </p>
            </div>
            <div className="flex justify-center"><IadaBadge size="md" /></div>
          </div>
        </div>

        <div className="mt-16 p-8 lg:p-12 border border-gray-200 rounded-2xl bg-gradient-to-br from-[#111827] via-[#0F172A] to-[#0B0F14] relative overflow-hidden">
          <div className="absolute inset-0 bg-grid opacity-30" />
          <div className="relative max-w-2xl">
            <Building2 className="w-8 h-8 text-[#F26A21]" />
            <h2 className="mt-4 text-3xl font-bold text-white font-display">¿Listo para activar tu portal partner?</h2>
            <p className="mt-3 text-gray-300">Agenda una demo de 30 minutos con nuestro equipo de partnerships institucionales.</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/contacto" data-testid="partners-contact-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] font-semibold text-sm transition-all">
                Agendar demo
              </Link>
              <Link to="/tailor-made" data-testid="partners-tailor-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-gray-500 text-white hover:bg-white/10 font-semibold text-sm">
                Ver Tailor-Made
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
